module.exports = __webpack_public_path__ + "static/media/clock.3344b663.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clock.svg
// module id = 1127
// module chunks = 1